export class URLSearchParamsCompat {
    constructor(init) {
        this.params = {};
        if (init) {
            Object.keys(init).forEach(key => {
                this.params[key] = init[key];
            });
        }
    }
    toString() {
        const parts = [];
        Object.keys(this.params).forEach(key => {
            const value = this.params[key];
            if (value !== undefined && value !== null) {
                parts.push(`${key}=${encodeURIComponent(value)}`);
            }
        });
        return parts.join('&');
    }
}
